import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { limitSearchTablePageCache } from "src/components/pages/search/components/table/helpers/limit-search-table-page-cache";

export const useLimitSearchTablePageCache = (pageSize: number, dataUpdatedAt: number) => {
    const queryClient = useQueryClient();

    useEffect(() => {
        if (dataUpdatedAt === 0) {
            return;
        }

        limitSearchTablePageCache(queryClient, pageSize);
    }, [queryClient, pageSize, dataUpdatedAt]);
};
